export function pushGtmDataLayer(category = 'Default category', action = 'Default action', label = 'Default label') {
    if (window['dataLayer']) {
        window['dataLayer'].push({
            'event'          : 'gaTriggerEvent',
            'gaEventCategory': category,
            'gaEventAction'  : action,
            'gaEventLabel'   : label,
        });
    } else {
        console.log('dataLayer object is unavailable');
    }
}

export function pushGtmActivateLayer(layer) {
    try {
        if (layer.layer_active.layer_lists.length > 1) {
            if(layer.layer_active.type === 'legend'){
                pushGtmDataLayer('Peta', 'Activate', `${layer.title} [${layer.id}]`);
            } else {
                layer.layer_active.layer_lists.forEach(subLayer => {
                    if(subLayer.is_active) {
                        pushGtmDataLayer('Peta', 'Activate', `${layer.title} - ${subLayer.label} [${layer.id};${subLayer.id}]`);
                    }
                });
            }
        } else{
            pushGtmDataLayer('Peta', 'Activate', `${layer.title} [${layer.id}]`);
        }
    } catch (e){
        console.log(e);
    }
}

export function pushGtmActivateSublayer(layer, subLayer){
    try {
        pushGtmDataLayer('Peta', 'Activate', `${layer.title} - ${subLayer.label} [${layer.id};${subLayer.id}]`);
    } catch (e) {
        console.log(e)
    }
}

export function pushGtmSearchCoordinate() {
    try{
        pushGtmDataLayer('Peta', 'Click', 'Cari lokasi - search koordinat');
    } catch (e) {
        console.log(e);
    }
}

export function pushGtmSearchProvince() {
    try{
        pushGtmDataLayer('Peta', 'Click', 'Cari lokasi - autosuggest provinsi');
    } catch (e) {
        console.log(e);
    }
}

export function pushGtmSearchArea(){
    try{
        pushGtmDataLayer('Peta', 'Click', 'Cari lokasi - autosuggest wilayah');
    } catch (e) {
        console.log(e);
    }
}

export function pushGtmDrawModeStart() {
    try{
        pushGtmDataLayer('Peta', 'Start', 'Draw mode');
    } catch (e) {
        console.log(e);
    }
}

export function pushGtmDrawModeReport() {
    try {
        pushGtmDataLayer('Peta', 'Report', 'Draw mode');
    } catch (e) {
        console.log(e);
    }
}

export function pushGtmActivateDetailPanel(layerId, layerName, subLayerId, sublayerName ) {
    try {
        pushGtmDataLayer('Peta', 'Activate', `Activate right panel [${layerName} - ${sublayerName} [${layerId};${subLayerId}]]`);
    } catch (e) {
        console.log(e)
    }
}

